export const getDecodedID = (id: string) => atob(id);
export const getEncodedID = (id: string) => btoa(id);
